var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rss-widget",style:(_vm.style)},[_c('RssViewer',{attrs:{"setting":_vm.rssSetting},on:{"saveData":_vm.saveAppData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }